export enum UserRole {
	admin = "admin",
	client = "client",
	portal = "portal",
	manager = "manager",
	managerPlus = "managerPlus",
	accountant = "accountant",
}
